import React from 'react';
import SchedulerListFunctional from './components/scheduler-list-functional';

const SchedulerList = () => {
	return <SchedulerListFunctional />;
};

export default SchedulerList;
